import React from "react";
import { openInteractivityModal } from "../../redux/modal/action";
import { connect } from "react-redux";
import {
  getPageNumber,
  getValue,
  sendAnalyticsEvent
} from "../../helper/utility";
import { setIndexCarousel } from "../../redux/carousel/action";
import { gaEventLabel } from "../../settings/gaConfig";
import { styles } from "./searchBar.styles";

const SearchResults = (props) => {
  return (
    <div
      style={styles.containerDescription(props.itemHeigth)}
      onClick={() => {
        sendAnalyticsEvent(
          gaEventLabel.searched_product,
          String(props.element.item_id)
        );
        sendAnalyticsEvent(
          gaEventLabel.open_product,
          String(props.element.item_id)
        );
        props.setIndexCarousel(getValue(getPageNumber(props.element.skul)));
        setTimeout(() => {
          const element = document.getElementById(
            `div-${props.element.item_id}`
          );
          if (element) {
            element.classList.add("fadeIn_interact");
            setTimeout(() => {
              element.classList.remove("fadeIn_interact");
            }, 1600);
          }
        }, 100);
      }}
      className="searchResultStyle row"
    >
      <p style={styles.description(props.itemHeigth)}>
        {props.element.description}
      </p>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    modalRedux: state.modal
  };
};

export default connect(mapStateToProps, {
  openInteractivityModal,
  setIndexCarousel
})(SearchResults);
